import {
  TableStateWithFilters,
  ColumnSortEnum,
} from "@king-ict/eupisi-ui/components";

import { Role } from "../../../models";
import { SchoolCandidateInstitutionAdminSearch } from "../../../models/SchoolCandidate";
import { SchoolCandidateInstitutionAdminSort } from "../../../models/SchoolCandidate/SchoolCandidateInstitutionAdminSort";
import { UserPermission } from "../../../models/User";
import { TableUtils } from "../../../utils";

/**
 * Creates an array of institution IDs based on the user's current role
 */
export const createInitialInstitutionIds = (
  currentRole: UserPermission | undefined
): number[] => {
  if (
    [Role.InstitutionAdministrator, Role.InstitutionPrincipal].includes(
      currentRole?.role ?? 0
    )
  ) {
    return currentRole?.locations?.length && currentRole?.locations[0]
      ? [currentRole.locations[0]]
      : ([] as number[]);
  }
  return [] as number[];
};

/**
 * Gets the initial table state from local storage
 */
export const getInitialTableState = (storageKey: string) => {
  return TableUtils.CreateInitialTableState<SchoolCandidateInstitutionAdminSearch>(
    storageKey,
    TableUtils.tableDefaultState(
      SchoolCandidateInstitutionAdminSort.Child,
      ColumnSortEnum.ASC
    )
  );
};

/**
 * Creates the initial search state for SchoolCandidateInstitutionAdmin
 */
export const createInitialSchoolCandidateInstitutionAdminSearch = ({
  initialTableState,
  defaultInstitutionIds,
}: {
  initialTableState: TableStateWithFilters<SchoolCandidateInstitutionAdminSearch>;
  defaultInstitutionIds: number[];
}): SchoolCandidateInstitutionAdminSearch => {
  const {
    institutionIds,
    childLastName,
    childFirstName,
    childOib,
    status,
    requestType,
    onlyWithAddReasonDelayPreviousYear,
    onlyWithTemporaryAddress,
    requestNotSubmitted,
  } = initialTableState;

  const initialInstitutionIds = institutionIds
    ? institutionIds
    : defaultInstitutionIds;

  return {
    institutionIds: initialInstitutionIds,
    childLastName,
    childFirstName,
    childOib,
    status,
    requestType,
    onlyWithAddReasonDelayPreviousYear,
    onlyWithTemporaryAddress,
    requestNotSubmitted,
  };
};
